import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, MessageCircle } from 'lucide-react';
export function PatternSection() {
  return <section className="py-24 px-4 relative overflow-hidden bg-[#FFF5F7]" data-id="element-154">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#f4b8c8] rounded-full mix-blend-multiply filter blur-[100px] opacity-15" data-id="element-155"></div>

      <div className="max-w-4xl mx-auto" data-id="element-156">
        <FadeIn data-id="element-157">
          <h2 className="text-3xl md:text-5xl font-serif text-[#c4607a] mb-12 text-center" data-id="element-158">
            El problema no es el tema de la pelea
          </h2>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-159">
          {['El dinero', 'El tiempo', 'La crianza', 'El cansancio'].map((item, i) => <FadeIn key={item} delay={i * 0.1} data-id="element-160">
                <div className="bg-white border border-[#f0d0dc] p-4 rounded-lg text-center text-[#7a5568] shadow-sm" data-id="element-161">
                  {item}
                </div>
              </FadeIn>)}
        </div>

        <FadeIn data-id="element-162">
          <div className="text-center mb-20" data-id="element-163">
            <p className="text-xl md:text-2xl text-[#4a2535] font-light italic" data-id="element-164">
              Pero el tema siempre cambia… y la sensación queda.
            </p>
            <p className="mt-6 text-lg text-[#7a5568]" data-id="element-165">
              Esa sensación de no ser escuchada. De hablar y chocar con una
              pared. De sentirte sola aun estando acompañada.
            </p>

            <div className="mt-12 p-6 bg-[#c4607a]/5 border-l-4 border-[#c4607a] text-left rounded-r-lg" data-id="element-166">
              <p className="text-xl md:text-2xl text-[#4a2535]" data-id="element-167">
                <span className="mr-2" data-id="element-168">👉</span>
                No pelean por el tema. Pelean por la emoción que nadie está
                pudiendo escuchar.
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="space-y-16" data-id="element-169">
          <FadeIn data-id="element-170">
            <h3 className="text-2xl md:text-4xl font-serif text-[#2d1520] mb-8 flex items-center gap-3" data-id="element-171">
              <AlertCircle className="text-[#c4607a]" data-id="element-172" />
              Cuando el cuerpo entra en modo defensa
            </h3>
            <p className="text-lg text-[#7a5568] mb-8" data-id="element-173">
              Cada conversación importante empieza igual:
            </p>
          </FadeIn>

          <div className="space-y-4" data-id="element-174">
            {['"Ya sé lo que vas a decir…"', '"No me grites…"', '"Siempre es lo mismo…"'].map((quote, i) => <FadeIn key={i} delay={i * 0.15} direction="left" data-id="element-175">
                <div className="bg-white p-4 rounded-xl rounded-tl-none ml-8 border border-[#f0d0dc] inline-block max-w-[80%] shadow-sm" data-id="element-176">
                  <p className="text-[#c4607a] font-serif text-lg italic" data-id="element-177">
                    {quote}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.3} data-id="element-178">
            <div className="mt-12 space-y-6 text-lg text-[#7a5568]" data-id="element-179">
              <p data-id="element-180">Y antes de escuchar… ya estás defendida.</p>
              <p data-id="element-181">
                No porque quieras discutir. Sino porque tu cuerpo aprendió que
                hablar duele.
              </p>
              <div className="bg-[#FEF0F3] p-8 rounded-2xl border border-[#f0d0dc] mt-8" data-id="element-182">
                <p className="text-xl font-serif text-[#4a2535] leading-relaxed" data-id="element-183">
                  "Intentar comunicarte en ese estado es como manejar con el
                  parabrisas empañado: no ves claro, reaccionás tarde y terminás
                  chocando."
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}